import React from 'react';
import clsx from 'clsx';
import styles from './closeButton.module.css';
import { CircularProgress } from '@mui/material';

const CloseButton = ({
  text,
  onClick,
  borderColor,
  color,
  loading,
  width,
  className,
}) => {
  return (
    <button
      className={clsx(styles.container, className)}
      onClick={onClick}
      style={{ borderColor: borderColor, width: width }}>
      {loading ? (
        <CircularProgress size={16} />
      ) : (
        <span style={{ color: color }} className={styles.text}>
          {text}
        </span>
      )}
    </button>
  );
};

export default CloseButton;
